<template>
  <v-dialog v-model="open" persistent max-width="700px">
    <v-card>

      <v-card-title>
        {{selectedNote.type ? `${selectedNote.type} ` : ''}}
        Note
      </v-card-title>

      <v-card-text class="mb-4">
        <div class="mb-2 d-flex justify-space-between align-center font-weight-bold">
          <div>{{selectedNote.user | username}}</div>
          <div>{{selectedNote.creation_timestamp | formatDate}}</div>
        </div>

        <span v-html="formatNoteMessage(selectedNote.note)"></span>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small outlined @click="closeDialog()">Close</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog> 
</template>

<script> 
  export default {
    props: {
      open: Boolean,
      selectedNote: Object,
    },

    methods: {
      formatNoteMessage(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
          return ''; 
        }
        
        const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },

      closeDialog() {
        this.$emit('closeDialog');
      },
    },

    filters: {
      username(username) {
        return username ? username.toLowerCase() : 'unassigned';
      },
    },
  }
</script>